import {DialogBody, DialogCloseTrigger, DialogContent, DialogHeader, DialogTitle} from "../../../components/ui/dialog";
import {Button, DataList, Image} from "@chakra-ui/react";
import {parseStringArray} from "./building";
import styled from "styled-components";
import {useEffect, useState} from "react";
import {getParcelRender} from "../../../services/services";
import {useNavigate} from "react-router";

const ButtonContainer = styled.div`
  display: flex;
  align-self: center;
  justify-content: center;
  margin-top: 24px;
`;

const RenderContainer = styled.div`
  display: flex;
  align-self: center;
  justify-content: center;
  padding-top: 24px;
`;

function BuildingDetails({ data }) {
    const { id, id_dzialki, miejscowosc_text, gmina, powiat, ulica, liczba_kondygnacji,
        liczba_samodzielnych_lokali, numer, powierzchnia_uzytkowa, przeznaczenie, lp
    } = data;
    const navigate = useNavigate();

    return <DialogContent>
        <DialogHeader>
            <DialogTitle>Szczegóły budynku</DialogTitle>
        </DialogHeader>
        <DialogBody pb="8">
            <DataList.Root orientation="horizontal">
                <DataList.Item>
                    <DataList.ItemLabel>Identyfikator budynku</DataList.ItemLabel>
                    <DataList.ItemValue>{id || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Identyfikator działki</DataList.ItemLabel>
                    <DataList.ItemValue>{parseStringArray(id_dzialki) || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Number budynku</DataList.ItemLabel>
                    <DataList.ItemValue>{parseStringArray(numer) || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Ulica</DataList.ItemLabel>
                    <DataList.ItemValue>{parseStringArray(ulica) || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Miejscowość</DataList.ItemLabel>
                    <DataList.ItemValue>{miejscowosc_text || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Gmina</DataList.ItemLabel>
                    <DataList.ItemValue>{parseStringArray(gmina) || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Powiat</DataList.ItemLabel>
                    <DataList.ItemValue>{parseStringArray(powiat) || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Województwo</DataList.ItemLabel>
                    <DataList.ItemValue>{parseStringArray(powiat) || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Przeznaczenie</DataList.ItemLabel>
                    <DataList.ItemValue>{przeznaczenie || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Liczba lokali</DataList.ItemLabel>
                    <DataList.ItemValue>{liczba_samodzielnych_lokali || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Liczba kondygnacji</DataList.ItemLabel>
                    <DataList.ItemValue>{liczba_kondygnacji || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Powierzchnia użytkowa</DataList.ItemLabel>
                    <DataList.ItemValue>{powierzchnia_uzytkowa || '-'}</DataList.ItemValue>
                </DataList.Item>
            </DataList.Root>
            <ButtonContainer>
                <Button
                    onClick={() => {
                        navigate('/zamowienie', {
                            state: {
                                order: {
                                    type: 'kw', register: {
                                        ...data,
                                        lp: `b${lp}`
                                    }
                                }
                            }
                        })
                    }}
                >Zakup księgę</Button>
            </ButtonContainer>
        </DialogBody>
        <DialogCloseTrigger />
    </DialogContent>
}

function ApartmentDetails({ data }) {
    const { id, miejscowosc_text, gmina, powiat, wojewodztwo, ulica, liczba_kondygnacji,
        kondygnacja, przeznaczenie, numer_lokalu, numer_budynku, lp
    } = data;
    const navigate = useNavigate();

    return <DialogContent>
        <DialogHeader>
            <DialogTitle>Szczegóły lokalu</DialogTitle>
        </DialogHeader>
        <DialogBody pb="8">
            <DataList.Root orientation="horizontal">
                <DataList.Item>
                    <DataList.ItemLabel>Identyfikator lokalu</DataList.ItemLabel>
                    <DataList.ItemValue>{id || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Number budynku</DataList.ItemLabel>
                    <DataList.ItemValue>{numer_budynku || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Number lokalu</DataList.ItemLabel>
                    <DataList.ItemValue>{numer_lokalu || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Ulica</DataList.ItemLabel>
                    <DataList.ItemValue>{ulica || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Miejscowość</DataList.ItemLabel>
                    <DataList.ItemValue>{miejscowosc_text || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Gmina</DataList.ItemLabel>
                    <DataList.ItemValue>{parseStringArray(gmina) || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Powiat</DataList.ItemLabel>
                    <DataList.ItemValue>{parseStringArray(powiat) || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Województwo</DataList.ItemLabel>
                    <DataList.ItemValue>{parseStringArray(wojewodztwo) || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Przeznaczenie</DataList.ItemLabel>
                    <DataList.ItemValue>{przeznaczenie || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Liczba kondygnacji</DataList.ItemLabel>
                    <DataList.ItemValue>{liczba_kondygnacji || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Kondygnacja</DataList.ItemLabel>
                    <DataList.ItemValue>{kondygnacja || '-'}</DataList.ItemValue>
                </DataList.Item>
            </DataList.Root>
            <ButtonContainer>
                <Button
                    onClick={() => {
                        navigate('/zamowienie', {
                            state: {
                                order: {
                                    type: 'kw', register: {
                                        ...data,
                                        lp: `l${lp}`
                                    }
                                }
                            }
                        })
                    }}
                >Zakup księgę</Button>
            </ButtonContainer>
        </DialogBody>
        <DialogCloseTrigger />
    </DialogContent>
}

function ParcelDetails({ data }) {
    const { id, nr_dzialki, miejscowosc, gmina, powiat, wojewodztwo, ulica, sposob_korzystania, lp } = data;
    const [parcelRenderUrl, setParcelRenderUrl] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        if (!id) {
            return undefined;
        }

        getParcelRender(id)
            .then(result => {
                if (result?.result) {
                    setParcelRenderUrl(result?.result);
                }
            });
    }, [id])

    return <DialogContent>
        <DialogHeader>
            <DialogTitle>Szczegóły działki ewidencyjnej</DialogTitle>
        </DialogHeader>
        <DialogBody pb="8">
            <DataList.Root orientation="horizontal">
                <DataList.Item>
                    <DataList.ItemLabel>Identyfikator działki</DataList.ItemLabel>
                    <DataList.ItemValue>{id || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Number działki</DataList.ItemLabel>
                    <DataList.ItemValue>{nr_dzialki || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Ulica</DataList.ItemLabel>
                    <DataList.ItemValue>{parseStringArray(ulica) || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Miejscowość</DataList.ItemLabel>
                    <DataList.ItemValue>{miejscowosc || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Gmina</DataList.ItemLabel>
                    <DataList.ItemValue>{gmina || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Powiat</DataList.ItemLabel>
                    <DataList.ItemValue>{powiat || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Województwo</DataList.ItemLabel>
                    <DataList.ItemValue>{wojewodztwo || '-'}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Sposób korzystania</DataList.ItemLabel>
                    <DataList.ItemValue>{sposob_korzystania || '-'}</DataList.ItemValue>
                </DataList.Item>
            </DataList.Root>
            {parcelRenderUrl && <RenderContainer>
                <Image rounded="md" src={parcelRenderUrl} alt="Granice działki" />
            </RenderContainer>}
            <ButtonContainer>
                <Button
                    onClick={() => {
                        navigate('/zamowienie', {
                            state: {
                                order: {
                                    type: 'kw', register: {
                                        ...data,
                                        lp: `d${lp}`
                                    }
                                }
                            }
                        })
                    }}
                >Zakup księgę</Button>
            </ButtonContainer>
        </DialogBody>
        <DialogCloseTrigger />
    </DialogContent>
}

function RegisterDetailsDialog({ registerDetails }) {
    const { data, type } = registerDetails;

    if (type === 'parcel') {
        return <ParcelDetails data={data} />
    }

    if (type === 'building') {
        return <BuildingDetails data={data} />
    }

    if (type === 'apartment') {
        return <ApartmentDetails data={data} />
    }

    return null;
}

export default RegisterDetailsDialog;
